// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"281":"5ce9991a","453":"5d1e1a24","501":"37b77ad1","925":"8deacede"}[chunkId] + ".chunk.js";
};